import { useMemo } from 'react';

import { Environment } from '../enum';

export const useEnvironment = () => {
  const environment = useMemo<Environment>(() => {
    const { href } = window.location;

    if (href.includes('junior.stg.openenglish')) {
      return Environment.stg;
    }

    if (href.includes('junior.local.openenglish') || href.includes('localhost')) {
      return Environment.local;
    }

    return Environment.prod;
  }, []);

  return {
    environment,
  };
};
